import { useAccountRepository } from '@frontend/repository';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../redux/store';

export const useBasketDetail = () => {
    const { currentAccount } = useAccountRepository();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    return {
        currentAccount,
        dispatch,
        navigate
    };
};
